<template>
  <v-container>
    <v-card
      v-for="(paymentMethod, index) in $store.state.tenant.paymentMethods"
      :key="index"
      outlined
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            {{$t('cap_pay')}} {{ formatMulti(paymentMethod.name) }}
          </v-list-item-title>
          <v-list-item-content v-if="typeof paymentMethod.message !== 'undefined'">
            {{ $t('cap_info_pay') }} {{ formatMulti(paymentMethod.message) }}
          </v-list-item-content>
        </v-list-item-content>
        <v-list-item-action>
          <CassEditPaymentMethod :locale="locale" :paymentMethod = "paymentMethod" :id="index" ></CassEditPaymentMethod>
          <v-btn text @click="onPayDelete(paymentMethod, index)">
            <v-icon>mdi-delete-forever</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card>
  </v-container>
</template>

<script>
import CassEditPaymentMethod from '../dialogs/CassEditPaymentMethod'
export default {
  components: { CassEditPaymentMethod },
  props: {
    locale: {
      type: String,
      default: 'en'
    },
    paymentMethods: {
      type: Array,
      default: '[{name: CASH}]'
    }
  },
  data: () => ({}),
  methods: {
    formatMulti(value) {
      if (typeof value === 'object') {
        if (Object.prototype.hasOwnProperty.call(value, this.locale)) {
          return value[this.locale]
        } else {
          return value.en
        }
      } else {
        return value
      }
    },
    onPayDelete(paymentMethod, index) {
      if (
        confirm(
          this.$t('cap_msg_delete_pro', {
            name: this.formatMulti(paymentMethod.name)
          })
        )
      ) {
        this.paymentMethods.splice(index, 1)
        this.$store.dispatch('tenant/addPayment', this.paymentMethods)
      }
    },
  }
}
</script>
